"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formConstants = void 0;
const formConstants = exports.formConstants = {
  optionalFields: {
    DEFAULT: "Default",
    NAME: "Name",
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    EMAIL: "Email",
    PASSWORD: "Password",
    CONFIRM_PASSWORD: "Confirm Password",
    PHONE: "Mobile Number",
    GEOGRAPHY: "Geography",
    LONG_ADDRESS: "Long Address",
    SHORT_ADDRESS: "Short Address"
  },
  requiredFields: {
    NAME: "Name *",
    FIRST_NAME: "First Name *",
    LAST_NAME: "Last Name *",
    EMAIL: "Email *",
    PASSWORD: "Password *",
    CONFIRM_PASSWORD: "Confirm Password *",
    PHONE: "Mobile Number *",
    OTP: "OTP *",
    GEOGRAPHY: "Geography *",
    LONG_ADDRESS: "Long Address *",
    SHORT_ADDRESS: "Short Address *"
  },
  buttons: {
    SAVE: "Save",
    RESET: "Reset",
    REGISTER: "Register",
    LOGIN: "Login",
    SEND: "Send",
    SENDING: "Sending...",
    SEND_OTP: "Send OTP",
    VERIFY: "Verify",
    VERIFY_OTP: "Verify OTP"
  },
  validations: {
    DEFAULT_BLANK: "Please fill the required fields",
    BLANK_EMAIL: "Email can't be blank",
    BLANK_PHONE: "Mobile number can't be blank",
    BLANK_OTP: "OTP can't be blank",
    INVALID_EMAIL: "Email is invalid",
    BLANK_PASSWORD: "Passsword can't be blank",
    PASSWORD_MISMATCH: "Password doesn't match",
    INVALID_PHONE: "Mobile number is invalid",
    INVALID_OTP: "OTP is invalid",
    AUTHORIZED: "Please login to proceed"
  }
};